export default "__VITE_ASSET__FmNr8y4G__"